import React from "react";
import './ConsultationPolygon.css';
import { ImTarget } from "react-icons/im";

const ConsultationPolygon = () => {
  return (
    <div class="bodyConsultationPolygon">
      <iframe 
        title="cognoseguridad" 
        src="https://cognoseguridad.com/form/formulario poligono/page/poligono.php" 
        width="100%"  
        frameborder="0" 
        marginheight="0" 
        marginwidth="0">
      </iframe>
    </div>
  );
};

export { ConsultationPolygon };